module.exports = __webpack_public_path__ + "LPF Flyer.pdf";